var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_5862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 16.4904 4.02254 21.0412 9.28125 21.8663V14.1797H6.48828V11H9.28125V8.57656C9.28125 5.81968 10.9235 4.29687 13.4361 4.29687C14.6396 4.29687 15.8984 4.51172 15.8984 4.51172V7.21875H14.5113C13.1449 7.21875 12.7188 8.06667 12.7188 8.93658V11H15.7695L15.2818 14.1797H12.7188V21.8663C17.9775 21.0412 22 16.4904 22 11Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2818 14.1797L15.7695 11H12.7188V8.93658C12.7188 8.06667 13.1449 7.21875 14.5113 7.21875H15.8984V4.51172C15.8984 4.51172 14.6396 4.29688 13.4361 4.29688C10.9235 4.29688 9.28125 5.81968 9.28125 8.57656V11H6.48828V14.1797H9.28125V21.8663C10.4202 22.0446 11.5798 22.0446 12.7188 21.8663V14.1797H15.2818Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_5862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookColor);
export default __webpack_public_path__ + "static/media/facebook-color.484c5fc92732bb18d4cafc19debf1a2e.svg";
export { ForwardRef as ReactComponent };